module.exports = flarum.core.compat['components/Checkbox'];